import styled from 'styled-components';
import { colorBlack900, fontFamilyRaleway, fontFamilyRoboto, mediaQueryMobileMin, mediaQueryMobileLargeMin, mediaQueryDesktopMin } from 'styleUtils';
export var ListHeader = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ik6rhc-0"
})(["display:flex;flex-direction:column;margin:0 0 16px 0;padding:0 16px;z-index:1;@media ", "{padding:0;}@media ", "{align-items:baseline;justify-content:space-between;flex-direction:row;}"], mediaQueryMobileMin, mediaQueryMobileLargeMin);
export var List = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ik6rhc-1"
})(["display:flex;flex-flow:column;width:100%;margin:0;padding:0;"]);
export var SorterWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ik6rhc-2"
})(["display:flex;justify-content:space-between;position:relative;"]);
export var SorterLabel = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-ik6rhc-3"
})(["font-family:", ";font-style:normal;font-weight:normal;font-size:14px;line-height:24px;color:", ";margin-right:8px;"], fontFamilyRoboto, colorBlack900);
export var TextCountWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ik6rhc-4"
})(["display:flex;flex-direction:column;margin:0 0 8px 0;@media ", "{margin:0;flex-direction:row;align-items:center;}"], mediaQueryDesktopMin);
export var TextCount = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-ik6rhc-5"
})(["font-family:", ";font-style:normal;font-weight:bold;font-size:16px;line-height:24px;color:", ";@media ", "{font-size:18px;}"], fontFamilyRaleway, colorBlack900, mediaQueryMobileLargeMin);